import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'
import DragWrapper from 'designer/component/system/layout/control/DragWrapper'
import WidgetComponent from 'designer/component/component/Widget'

export const WidgetSystem = (props) => {
  return (
    <DragWrapper {...props}>
      <WidgetComponent {...props} />
    </DragWrapper>
  )
}

export const WidgetDisplay = (props) => {
  return (
    <ComponentWrapper {...props}>
      <WidgetComponent {...props} />
    </ComponentWrapper>
  )
}

export const widgetTester = rankWith(3, and(scopeEndsWith('widget')))

export const widgetSystem = {
  tester: widgetTester,
  renderer: withJsonFormsControlProps(WidgetSystem),
}

export const widgetDisplay = {
  tester: widgetTester,
  renderer: withJsonFormsControlProps(WidgetDisplay),
}
